import { uiRows } from './types-def.js';
/** `web/read` (1.W): reading and the table-read. */
export const READ_INTERACTIONS = uiRows([
    {
        id: 'read.table-read.strips',
        module: 'web/read',
        behavior: 'The table-read shows no secret, GM note or stage direction',
        owner: '1.W',
        since: 'exit-1a',
    },
]);
//# sourceMappingURL=read.js.map